$(window).bind('load', function(){

	var itemSelector = '.element-item';

	var $container = $('#cate_report_list').isotope({
		itemSelector: itemSelector,
		masonry: {
			columnWidth: itemSelector,
			isFitWidth: false } });

	// layout Isotope after each image loads
	$container.imagesLoaded().progress( function() {
	  $container.isotope('layout');
	});

	//Ascending order
	var responsiveIsotope = [
	[480, 6],
	[720, 6]];


	var itemsPerPageDefault = 6;
	var itemsPerPage = defineItemsPerPage();
	var currentNumberPages = 1;
	var currentPage = 1;
	var currentFilter = '*';
	var filterAtribute = 'data-group';
	var pageAtribute = 'data-page';
	var pagerClass = 'pagination';

	function changeFilter(selector) {
		$container.isotope({
			filter: selector });

	}


	function goToPage(n) {
		currentPage = n;

		var selector = itemSelector;
		selector += currentFilter != '*' ? '[' + filterAtribute + '="' + currentFilter + '"]' : '';
		selector += '[' + pageAtribute + '="' + currentPage + '"]';

		changeFilter(selector);
	}

	function defineItemsPerPage() {
		var pages = itemsPerPageDefault;

		for (var i = 0; i < responsiveIsotope.length; i++) {if (window.CP.shouldStopExecution(0)) break;
			if ($(window).width() <= responsiveIsotope[i][0]) {
				pages = responsiveIsotope[i][1];
				break;
			}



		}window.CP.exitedLoop(0);

		return pages;
	}
	
	function goToByScroll(id) {
		// Remove "link" from the ID
		id = id.replace("link", "");
		// Scroll
		$('html,body').animate({
			scrollTop: $("#" + id).offset().top - 50
		}, 'slow');
	}

	function setPagination() {

		var SettingsPagesOnItems = function () {

			var itemsLength = $container.children(itemSelector).length;

			var pages = Math.ceil(itemsLength / itemsPerPage);
			var item = 1;
			var page = 1;
			
			var selector = itemSelector;
			selector += currentFilter != '*' ? '[' + filterAtribute + '="' + currentFilter + '"]' : '';

			$container.children(selector).each(function () {
				if (item > itemsPerPage) {
					page++;
					item = 1;
				}
				$(this).attr(pageAtribute, page);
				item++;
			});

			currentNumberPages = page;

		}();
		var itemsLength = $container.children(itemSelector).length;
		if(itemsLength > itemsPerPage) {
			var CreatePagers = function () {

				var $isotopePager = $('.' + pagerClass).length == 0 ? $('<div class="' + pagerClass + '"></div>') : $('.' + pagerClass);				
				var active = 'active';
				$isotopePager.html('');

				var $pager_prev = '<a href="javascript:void(0);" class="pager prev"></a>',
					$pager_next = '<a href="javascript:void(0);" class="pager next"></a>';

				for (var i = 0; i < currentNumberPages; i++) {if (window.CP.shouldStopExecution(1)) break;
					if(i>0) active = '';
					var $pager = $('<a href="javascript:void(0);" class="pager ' + active + '" ' + pageAtribute + '="' + (i + 1) + '"></a>');
					$pager.html(i + 1);

					$pager.click(function () {
						$('.pager').removeClass('active');
						var page = $(this).eq(0).attr(pageAtribute);
						$(this).addClass('active');
						goToPage(page);
						// scroll to top of container on layoutComplete
						//window.scroll(0, 0);
						goToByScroll ('contents');						
						return false;
					});

					$pager.appendTo($isotopePager);
				}window.CP.exitedLoop(1);

				$isotopePager.append($pager_next)
					.prepend($pager_prev);

				$(document).on('click', '.pager.next', function () {
					const $active_page = Number($('.pager.active').data('page'));

					if( $active_page !== currentNumberPages ) {
						$('.pager').removeClass('active');
						$('a[data-page="'+ ($active_page+1) +'"]').addClass('active');
						goToPage($active_page);
						goToByScroll ('contents');
					}

					return false;
				});

				$(document).on('click', '.pager.prev', function () {
					const $active_page = Number($('.pager.active').data('page'));

					if( $active_page !== 1 ) {
						$('.pager').removeClass('active');
						$('a[data-page="'+ ($active_page-1) +'"]').addClass('active');
						goToPage($active_page);
						goToByScroll ('contents');
					}
					return false;
				});

				$container.after($isotopePager);

			}();
		}

	}

		setPagination();
		goToPage(1);
	

	//Adicionando Event de Click para as categorias
	$('#filters a').click(function (e) {
		$('#filters a').removeClass('active');
		e.preventDefault();
		var filter = $(this).attr(filterAtribute);
		currentFilter = filter;
		$(this).addClass('active');
			setPagination();
			goToPage(1);
	});

	//Evento Responsivo
	$(window).resize(function () {
		itemsPerPage = defineItemsPerPage();
			setPagination();
			goToPage(1);
	});

});